//============================================================================================================
//Function to get the color of a table cell based on bid and best values
//============================================================================================================
export function getCellColor(
    bid,
    best,
    {
        noData = "white", // If no data, return white
        bestColor = "var(--color-green)", // Green   for best bid
        nearBest = "var(--color-green-light)", // Light green for near best (until 5% more than best)
        bad = "var(--color-red)", // Red for bad bid (double or more than best)
        midBad = "var(--color-red-light)", // Light red for mid bad (between 50% and 100% more than best)
        fallback = "white", // Fallback color
        nearPct = 0.05, // Percentage for near best
        midBadMin = 1.5, // Minimum ratio for mid bad
        badMin = 2.0 // Minimum ratio for bad
    } = {}
) {
    if (bid == null || best == null) return noData;
    if (bid === best) return bestColor;

    const ratio = bid / best; // Calculate the ratio of bid to best
    if (ratio <= 1 + nearPct) return nearBest; // If within 5% of best, return near best color
    if (ratio >= badMin) return bad; // If bid is double or more than best, return bad color
    if (ratio >= midBadMin) return midBad; // If bid is between 50% and 100% more than best, return mid bad color
    return fallback; // If none of the conditions match, return fallback color
}

//============================================================================================================
// Base styles for table headers and cells
//============================================================================================================
export const baseHeaderCellStyle = {
    border: "2px solid var(--color-black)",
    padding: "5px",
    background: "var(--color-grey)",
    textAlign: "center",
};

//============================================================================================================
// Base styles for sub-headers and cells, if needed
//============================================================================================================
export const baseSubHeaderCellStyle = {
    border: "2px solid var(--color-black)",
    padding: "5px",
    background: "var(--color-grey)",
    textAlign: "center",
};

//============================================================================================================
// Base styles for table cells
//============================================================================================================
export const baseCellStyle = {
    border: "2px solid var(--color-black)",
    padding: "5px",
    textAlign: "center",
};

//============================================================================================================
// Helpers for creating styled headers and cells with overrides
//============================================================================================================
export const headerCellStyle = (overrides = {}) => ({ ...baseHeaderCellStyle, ...overrides });
export const subHeaderCellStyle = (overrides = {}) => ({ ...baseSubHeaderCellStyle, ...overrides });
export const cellStyle = (overrides = {}) => ({ ...baseCellStyle, ...overrides });
